import { CodeNode } from '@lexical/code';
import createFallbackNodeClass from './factory.mjs';

var FallbackCodeNode = createFallbackNodeClass(CodeNode.getType(), "block");

export { FallbackCodeNode as default };
//# sourceMappingURL=code.mjs.map
